/**
 * [INPUT]: 依赖同模块代码与项目公共基础设施能力
 * [OUTPUT]: 对外提供 request 相关实现
 * [POS]: 位于 jeepay-ui\jeepay-ui-cashier\src\http，接口访问层，负责请求封装与响应适配
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import HttpRequest from '@/http/HttpRequest'

const request = new HttpRequest()
export default request
